import {
  GetCampaignModel,
  GetResponseCampaignModel,
} from "@factory/model/query-model-campaign";

export function rowsFromCampaignApiResponse(
  response: GetResponseCampaignModel
): GetCampaignModel[] {
  return response.data || [];
}

export type ResolveCampaignImageResult = {
  code: string;
  blobUrl: string | null;
};

export async function resolveCampaignImageBlob(
  element: GetCampaignModel,
  viewAsset: (path: string) => Promise<File>
): Promise<ResolveCampaignImageResult | null> {
  if (!element.image) {
    return null;
  }

  try {
    const file = await viewAsset(element.image);
    return { code: element.code, blobUrl: URL.createObjectURL(file) };
  } catch {
    return { code: element.code, blobUrl: null };
  }
}
